import { toCamelCase } from "./StringHelpers";

export const isLinkExternal = (linkElement: HTMLAnchorElement) => {
  return location.host !== linkElement.host && (linkElement.href.substring(0, 4) === "http" || linkElement.href.substring(0, 5) === "https");
};

export const isElementHidden = (element: HTMLElement) => {
  return element.offsetParent === null;
};

export const attributesToObject = (el: HTMLElement) => {
  const result = {};
  for (const attribute of el.attributes) {
    if (attribute.name === "class") continue;
    let tempVal: any = attribute.value;
    if (attribute.name !== "postal-code-from-page")
      tempVal = isNaN(Number(attribute.value)) ? attribute.value : parseFloat(attribute.value);
    result[toCamelCase(attribute.name)] = tempVal;
  }
  return result;
};
